import { styled } from "@mui/material/styles"
import Switch, { SwitchProps } from "@mui/material/Switch"

type StyledSwitchProps = {
  defaultChecked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

export default function StyledSwitch(props: StyledSwitchProps) {
  const { defaultChecked, disabled, onChange } = props

  return <CustomSwitch
    disabled={disabled}
    defaultChecked={defaultChecked}
    onChange={e => onChange(e.target.checked)}
  />
}

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  height: 32,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    right: 0,
    left: "auto",
    transitionDuration: "300ms",
    color: theme.palette.gray["3"],

    "&.Mui-checked": {
      transform: "translateX(-26px)",
      color: theme.palette.primary["6"],

      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary["3"],
        opacity: 1,
        border: 0
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5
      }
    },

    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff"
    },

    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600]
    },

    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3
    }
  },

  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 28,
    height: 28
  },

  "& .MuiSwitch-track": {
    borderRadius: 18,
    backgroundColor: theme.palette.gray["7"],
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500
    })
  }
}))
